import { Field } from 'react-final-form';
import { ChangeEvent, useCallback, useState, FocusEvent, useEffect } from 'react';

import { TextInput } from 'UIPackage/MainModule/components/TextInput';
import { AutoComplete } from 'UIPackage/MainModule/components/AutoComplete';
import {
  IRequirementStructuralUnitItem,
  IRequirementStructuralUnitType,
} from 'APIPackage/RequirementsNpaModule/interfaces/IRequirementStructuralUnit';

import styles from './AutoSelectSuElement.module.scss';

interface IAutoSelectSuElementProps {
  disabled?: boolean;
  name: string;
  options?: IRequirementStructuralUnitType[];
  onChange: (value: IRequirementStructuralUnitType) => void;
  fieldValue: IRequirementStructuralUnitItem;
}
export const AutoSelectSuElement = ({ disabled, name, options, onChange, fieldValue }: IAutoSelectSuElementProps) => {
  const [innerOptions, setInnerOptions] = useState<IRequirementStructuralUnitType[]>();
  const [inputValue, setInputValue] = useState(fieldValue.selectType?.label);

  useEffect(() => {
    setInputValue(fieldValue.selectType?.label);
  }, [fieldValue]);

  const handleFullNameChange = useCallback(
    (value: string) => {
      if (value) {
        setInnerOptions(
          options?.filter(item => item.label.toLowerCase().indexOf(value.toLowerCase()) > -1).map(item => item),
        );
      } else {
        setInnerOptions(options);
      }
    },
    [options],
  );

  return (
    <Field name={name}>
      {({ input, meta }) => {
        function handleTextInputBlur(e: FocusEvent<HTMLInputElement>) {
          const tagName = (e?.relatedTarget as Element)?.tagName;

          if (tagName !== 'UL') {
            if (inputValue) {
              if (!input.value) {
                setInputValue('');
              } else {
                setInputValue(input.value?.label || '');
              }
            } else if (input.value) {
              setInputValue(input.value.label);
            }
            input.onBlur(e);
            setInnerOptions(undefined);
          }
        }

        function handleAutoCompleteChange(e: ChangeEvent<HTMLInputElement>) {
          const { value } = e.target;

          setInputValue(value);
          handleFullNameChange(value);
        }

        function handleAutoCompleteSelect(value: string) {
          return () => {
            const found = innerOptions?.find(i => i.value === value);

            if (found) {
              onChange(found);
              input.onChange(found);
            }
            setInnerOptions(undefined);
          };
        }

        const onFocus = useCallback(
          (e: FocusEvent<HTMLInputElement>) => {
            input.onFocus(e);
            if (inputValue) {
              setInnerOptions(options?.filter(i => i.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1));
            } else {
              setInnerOptions(options);
            }
          },
          [inputValue, options],
        );

        const error = meta.touched && meta.error ? meta.error : undefined;

        return (
          <div className={styles.Wrapper}>
            <AutoComplete
              options={innerOptions}
              noFoundMessage="Значение отсутствует"
              handleAutoCompleteSelect={handleAutoCompleteSelect}
            >
              <TextInput
                {...input}
                value={inputValue}
                placeholder="Единица"
                error={error}
                disabled={disabled}
                onChange={handleAutoCompleteChange}
                onBlur={handleTextInputBlur}
                autoComplete={'off'}
                onFocus={onFocus}
              />
            </AutoComplete>
          </div>
        );
      }}
    </Field>
  );
};
